var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgInfo = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.9998 4.79163C53.1393 4.79163 67.2095 18.6734 67.2095 36.0013C67.2095 53.2376 53.2504 67.211 35.9998 67.211C18.7704 67.211 4.79016 53.2588 4.79016 36.0013C4.79016 18.7778 18.7481 4.79163 35.9998 4.79163ZM35.9998 0.167969C16.211 0.167969 0.166504 16.2183 0.166504 36.0013C0.166504 55.7959 16.211 71.8346 35.9998 71.8346C55.7887 71.8346 71.8332 55.7959 71.8332 36.0013C71.8332 16.2183 55.7887 0.167969 35.9998 0.167969ZM34.3397 17.5067H37.6599C38.6457 17.5067 39.4333 18.3277 39.3923 19.3128L38.3809 43.587C38.3422 44.5158 37.5781 45.2486 36.6485 45.2486H35.3511C34.4216 45.2486 33.6574 44.5156 33.6187 43.587L32.6072 19.3128C32.5663 18.3277 33.3538 17.5067 34.3397 17.5067ZM35.9998 48.1384C33.7655 48.1384 31.9541 49.9497 31.9541 52.1841C31.9541 54.4185 33.7655 56.2298 35.9998 56.2298C38.2342 56.2298 40.0455 54.4185 40.0455 52.1841C40.0455 49.9497 38.2342 48.1384 35.9998 48.1384Z",
    fill: "#77BED2"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInfo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "App/static/media/info.9ee4d761d2b95ecb5b6c68e553264b90.svg";